import { combineEpics } from 'redux-observable';
import { userLoggedInEpic } from './user-logged-in';
import { userLoggedOutEpic } from './user-logged-out';
import { registrationSuccessEpic } from './registration-success';
import { verificationSuccessEpic } from './verification-success';
import { forgotPasswordEpic } from './forgot-password';

const historyEpic = combineEpics(
  userLoggedInEpic,
  userLoggedOutEpic,
  registrationSuccessEpic,
  verificationSuccessEpic,
  forgotPasswordEpic,
);

export default historyEpic;